var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.578 15.8511L15.6278 20.9268C16.3882 21.6911 17.6166 21.6911 18.377 20.9268L23.4268 15.8511C24.6551 14.6165 23.7777 12.5 22.0424 12.5H11.9429C10.2076 12.5 9.34972 14.6165 10.578 15.8511Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowimg);
export default __webpack_public_path__ + "static/media/Arrowimg.aab6f713f6cdb84589bd73fe94826e72.svg";
export { ForwardRef as ReactComponent };